import React, { useState, useEffect, Fragment } from "react";
import {
  Typography,
  Switch,
  Box,
  RadioGroup,
  Radio,
  FormControlLabel,
  FormControl,
} from "@material-ui/core";

import Theme, { useStyles } from "../../../../Theme.js";
//images
import POTABLE from "../../../../../images/pictos-ok/POTABLE.svg";
import NONPOTABLE from "../../../../../images/pictos-ok/NON POTABLE.svg";
import PAS_INDICATION from "../../../../../images/pictos-ok/PAS_INDICATION.svg";

const Step1 = (props) => {
  const classes = useStyles();
  const [value, setValue] = useState({
    presence: false,
  });
  const [potabilite, setPotabilite] = useState({});

  useEffect(() => {
    // Quand le composant se charge, n'autorise pas à passer à la suite
    props.setAuthorization(false);
    // Insérer les réponses par défaut des switch dans la réponse
    for (let element in value) {
      props.result[element] = value[element];
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChange = (event) => {
    // Set la value du state du composant local

    ///setValue({ ...value, [event.target.name]: event.target.checked });
    setValue({ ...value, [event.target.name]: event.target.checked });
    // Set la value du state du composant parent
    let newResult = props.result;
    newResult[event.target.name] = event.target.checked;
    props.setResult(newResult);
  };

  const handleRadioChange = (event) => {
    // Set la value du state du composant local pour rendu graphique
    setPotabilite(event.target.value);
    // Set la value du state du composant parent
    let newResult = props.result;
    newResult["potabilite"] = event.target.value;
    props.setResult(newResult);
    // Une fois que la réponse est donnée, autorise à avancer dans le form
    props.setAuthorization(true);
  };

  return (
    <Fragment>
      <Typography variant="body1" component="legend" style={{ marginLeft: 20 }}>
        J'indique la présence ou le manque de point d'eau
      </Typography>
      <Box
        style={{
          marginTop: 20,
          display: "flex",
          justifyContent: "space-around",
        }}
      >
        <Typography
          variant="body1"
          style={{ display: "flex", alignItems: "center" }}
        >
          Absence
        </Typography>
        <Switch
          name="presence"
          checked={value.presence}
          onChange={handleChange}
        />
        <Typography
          variant="body1"
          style={{ display: "flex", alignItems: "center" }}
        >
          Présence
        </Typography>
      </Box>
      <Typography
        variant="body1"
        style={{ textAlign: "center", marginTop: 20 }}
      >
        L'eau est indiquée...
      </Typography>
      <FormControl component="fieldset">
        <RadioGroup
          aria-label="potabilite"
          name="potabilite"
          value={potabilite}
          onChange={handleRadioChange}
          row
          style={{ marginTop: "15px", marginLeft: 0, justifyContent: "center" }}
        >
          <FormControlLabel
            value="potable"
            className={
              classes.themeButton +
              " " +
              (potabilite === "potable" ? "checked" : "")
            }
            control={
              <Radio
                className={classes.fullradio}
                icon={
                  <img
                    style={{
                      maxHeight: 65,
                      maxWidth: "100%",
                      marginBottom: "10px",
                    }}
                    src={POTABLE}
                    alt="Potable"
                  />
                }
                checkedIcon={
                  <img
                    style={{
                      maxHeight: 65,
                      maxWidth: "100%",
                      marginBottom: "10px",
                    }}
                    src={POTABLE}
                    alt="Potable"
                  />
                }
              />
            }
            label="potable"
          />
          <FormControlLabel
            value="non_potable"
            className={
              classes.themeButton +
              " " +
              (potabilite === "non_potable" ? "checked" : "")
            }
            control={
              <Radio
                className={classes.fullradio}
                icon={
                  <img
                    style={{
                      maxHeight: 65,
                      maxWidth: "100%",
                      marginBottom: "10px",
                    }}
                    src={NONPOTABLE}
                    alt="non potable"
                  />
                }
                checkedIcon={
                  <img
                    style={{
                      maxHeight: 65,
                      maxWidth: "100%",
                      marginBottom: "10px",
                    }}
                    src={NONPOTABLE}
                    alt="non potable"
                  />
                }
              />
            }
            label="non potable"
          />
          <FormControlLabel
            value="pas_d'indication"
            className={
              classes.themeButton +
              " " +
              (potabilite === "pas_d'indication" ? "checked" : "")
            }
            control={
              <Radio
                className={classes.fullradio}
                icon={
                  <img
                    style={{
                      maxHeight: 65,
                      maxWidth: "100%",
                      marginBottom: "10px",
                    }}
                    src={PAS_INDICATION}
                    alt="pas d'indication"
                  />
                }
                checkedIcon={
                  <img src={PAS_INDICATION} alt="pas d'indication" />
                }
              />
            }
            label="pas d'indication"
          />
        </RadioGroup>
      </FormControl>
    </Fragment>
  );
};

export default Step1;
